import DATAMON_LOGO from '../../assets/img/datamon-logo.png';
import ETM_LOGO from '../../assets/img/etm-logo.webp';
import SPMS_LOGO from '../../assets/img/spms-logo.png';
import CESAE_LOGO from '../../assets/img/cesae-logo.png';
import ING_LOGO from '../../assets/img/ing-logo.png';
import RUMOS_LOGO from '../../assets/img/rumos-logo.png';

export const workExperience = [
  {
    logo: ING_LOGO,
    title: 'Tech Lead',
    company: 'ING Group',
    link: 'https://www.ing.com/Home.htm',
    duration: '07/2022 - Present',
  },
  {
    logo: SPMS_LOGO,
    title: 'Full Stack Developer',
    company: 'Shared Services for Portuguese Ministry of Health',
    link: 'https://www.spms.min-saude.pt/2020/07/pem/#googtrans(pt%7Cen)',
    duration: '05/2020 - 06/2022',
  },
  {
    logo: DATAMON_LOGO,
    title: 'Software Consultant',
    company: 'DatamonPlus',
    link: 'https://datamonplus.com/pt-pt/',
    duration: '11/2019 - 05/2020',
  },
  {
    logo: ETM_LOGO,
    title: 'Software Consultant',
    company: 'ETM Textile',
    link: 'https://textilmaganha.com/en/',
    duration: '02/2019 - 10/2019',
  },
];

export const instructorExperience = [
  {
    logo: RUMOS_LOGO,
    title: 'IT Instructor',
    company: 'Rumos',
    link: 'https://www.rumos.pt/',
    duration: '01/2023 - Present',
  },
  {
    logo: CESAE_LOGO,
    title: 'IT Instructor',
    company: 'CESAE - Training Center for Technical Certification',
    link: 'https://www.cesaedigital.pt/',
    duration: '05/2022 - 10/2022',
  },
];
